module.exports = __webpack_public_path__ + "static/media/6.b20d9c2a.jpg";